module.exports = __webpack_public_path__ + "static/img/pay_bg.c3afeeb7.png";